import React from 'react';
import { useLazyQuery } from '@apollo/client';
import ValidationQuery from './ValidationQuery';

interface IDietSettingsValidateConnectorApolloProps {
  children: ({
    validateGoalSettings,
  }: {
    validateGoalSettings: (variables: any) => void;
  }) => React.ReactElement;
}

const DietSettingsValidateConnectorApollo: React.FC<IDietSettingsValidateConnectorApolloProps> = ({
  children,
}) => {
  const [validate] = useLazyQuery(ValidationQuery);

  const validateGoalSettings = async (variables: any) => {
    const result = await validate({
      variables: variables,
      fetchPolicy: 'no-cache',
    });

    return result.data?.me.validateGoalSettings;
  };
  return children({ validateGoalSettings });
};

export default DietSettingsValidateConnectorApollo;
